import type { SettingsTab } from "@octopus-settings/types";
import { ChartingIcon, AudiencesIcon } from "@ui/icons";
import {
  OVERVIEW_PATH,
  PEOPLE_PATH,
} from "@octopus-settings/constants/config/router";
import {
  SETTINGS_OVERVIEW_TAB_TEST_ID,
  SETTINGS_PEOPLE_TAB_TEST_ID,
} from "@octopus-settings/constants/testIds/settingsPage";
import { OVERVIEW_TITLE } from "@octopus-settings/constants/ui/overview";
import { PEOPLE_TITLE } from "@octopus-settings/constants/ui/people";

const settingsTabsConfiguration: SettingsTab[] = [
  {
    id: OVERVIEW_PATH,
    route: OVERVIEW_PATH,
    label: OVERVIEW_TITLE,
    icon: ChartingIcon,
    testId: SETTINGS_OVERVIEW_TAB_TEST_ID,
    tabIndex: 0,
    requiresAdmin: false,
  },
  {
    id: PEOPLE_PATH,
    route: PEOPLE_PATH,
    label: PEOPLE_TITLE,
    icon: AudiencesIcon,
    testId: SETTINGS_PEOPLE_TAB_TEST_ID,
    tabIndex: 1,
    requiresAdmin: false,
  },
  // {
  //   id: API_MCP_PATH,
  //   route: API_MCP_PATH,
  //   label: API_MCP_TITLE,
  //   icon: GlobeIcon,
  //   testId: SETTINGS_API_MCP_TAB_TEST_ID,
  //   tabIndex: 2,
  //   requiresAdmin: true,
  // }, enable in OOP2
];

export const getSettingsTabs: SettingsTab[] = [
  ...settingsTabsConfiguration,
].sort((a, b) => a.tabIndex - b.tabIndex);

export function getVisibleSettingsTabs(): SettingsTab[] {
  return getSettingsTabs.filter((tab) => !tab.requiresAdmin);
}

export function getTabPath(tab: SettingsTab): string {
  return `/${tab.route}`;
}

export function isTabPathActive(pathname: string, tab: SettingsTab): boolean {
  const tabPath = getTabPath(tab);
  return pathname === tabPath || pathname.startsWith(`${tabPath}/`);
}
